/* @flow */
import * as React from 'react';

import AdminUpgradePageView from 'admin/components/AdminUpgradePageView.jsx';
import AdminUpgradeQuoteBox from 'admin/components/AdminUpgradeQuoteBox.jsx';
import AdminUpgradeQuoteTotalBox from 'admin/components/AdminUpgradeQuoteTotalBox.jsx';
import AdminUpgradeHelp from 'admin/components/AdminUpgradeHelp.jsx';
import AdminUpgradePageHeader from 'admin/components/AdminUpgradePageHeader.jsx';
import AdminUpgradeTitle from 'admin/components/AdminUpgradeTitle.jsx';
import AdminUpgradeInfo from 'admin/components/AdminUpgradeInfo.jsx';
import Button from 'components/Button.jsx';
import Buttons from 'components/Buttons.jsx';
import EventTracking from 'lib/EventTracking';
import Row from 'components/Row.jsx';

import './styles/AdminUpgradePageView.scss';

type Props = {
  quote: *,
  referredFromSales: ?boolean,
};

type State = {
  preview: boolean,
};

export default class AdminUpgradeSharedQuoteFound extends React.Component<Props, State> {
  state: State = { preview: true };

  static trackingPrefix = 'admin_self_serve.shared_quote';

  componentDidMount() {
    this.track('view');
  }

  track = (key: string) => {
    EventTracking.trackKey(`${AdminUpgradeSharedQuoteFound.trackingPrefix}.${key}`);
  };

  render() {
    const { quote, referredFromSales } = this.props;
    const { preview } = this.state;

    if (preview) {
      const address = [quote.organization.city, quote.organization.state]
        .filter(Boolean)
        .join(', ');
      return (
        <div className="AdminUpgradePageView">
          <AdminUpgradePageHeader title="Purchase a Remind Plan" />
          <div className="AdminUpgradePageView-content">
            <div className="AdminUpgradePageView-content-body">
              <div className="AdminUpgradePageView-content-body-forms">
                <Row>
                  <AdminUpgradeTitle
                    text={
                      quote.organization.type
                        ? `${quote.organization.type} Remind Plan quote`
                        : 'Your Remind Plan quote'
                    }
                    subtext={
                      quote.organization.type
                        ? `Meaningful communication for every student, teacher, and parent at your ${quote.organization.type.toLowerCase()}`
                        : 'Meaningful communication for every student, teacher, and parent.'
                    }
                  />
                </Row>
                <AdminUpgradeQuoteBox
                  orgName={quote.organization.name}
                  orgAddress={address}
                  orgType={quote.organization.type || 'School'}
                  startDate={quote.startDate}
                  endDate={quote.endDate}
                  price={quote.price}
                  taxExempt={quote.taxExempt}
                  tax={quote.tax}
                />
                <AdminUpgradeQuoteTotalBox quote={quote} />
              </div>
              <div className="AdminUpgradePageView-content-body--desktop-side">
                <Row size="large">
                  <AdminUpgradeInfo />
                </Row>
              </div>
            </div>
          </div>
          <div className="AdminUpgradePageView-footer">
            <Buttons>
              <Button
                onClick={() => {
                  this.setState({ preview: false });
                  this.track('continue.click');
                }}
                className="AdminUpgradePageView-footer-button">
                Continue this purchase
              </Button>
            </Buttons>
          </div>
          <div className="AdminUpgradePageView--mobile-bottom">
            <Row size="medium">
              <AdminUpgradeHelp full />
            </Row>
            <div className="AdminUpgradePageView-info-container">
              <AdminUpgradeInfo />
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <AdminUpgradePageView
          organizationUuid={quote.organization.uuid}
          organizationType={quote.organization.type}
          quote={quote}
          referredFromSales={referredFromSales}
        />
      );
    }
  }
}
